import React, { useState, useEffect } from "react";
import { StreamChat } from 'stream-chat';
import { Chat as StreamChatWrapper } from 'stream-chat-react';

import ChatWrapper from './Chat';
import PropTypes from 'prop-types';

function App({ user_id, api_key, token: rawToken, is_supervisor, user_name }) {

  const [token, setToken] = useState(rawToken);
  const [chatClient, setChatClient] = useState(null);

  useEffect(() => {
    // Initialize Stream Chat client
    const client = StreamChat.getInstance(api_key);
    
    console.log("Connecting to Stream Chat with user_id:", user_id);

    // Connect user
    client.connectUser(
      {
        id: user_id,
        name: user_name || user_id, // Use the passed user name, fallback to user_id
      },
      token
    );

    setChatClient(client);

    // Cleanup function
    return () => {
      if (client) {
        client.disconnectUser();
      }
    };
  }, [user_id, api_key, token]);

  if (!chatClient) {
    return <div>Loading chat...</div>;
  }

  return (
    <StreamChatWrapper client={chatClient}>
      <ChatWrapper {...{ setToken, user_id, is_supervisor }} />
    </StreamChatWrapper>
  )

}
App.propTypes = {
  user_id: PropTypes.string.isRequired,
  api_key: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  is_supervisor: PropTypes.bool,
  user_name: PropTypes.string
};

export default App;